import { type INotyfPosition, Notyf } from 'notyf';

import { type IMediator } from '#/core/mediator';

import { SERVICES_TYPES } from '#/services-types';

import { type ILogService } from '../log';
import { type IThemeService } from '../theme';

import './notification.styles.scss';
import { type INotificationService } from './notification.types';

export class NotificationService implements INotificationService {
  readonly #serviceName = 'NotificationService';

  get #themeService() {
    return this._mediator.get<IThemeService>(SERVICES_TYPES.ThemeService);
  }
  get #logService() {
    return this._mediator.get<ILogService>(SERVICES_TYPES.LogService);
  }

  readonly #notification: Notyf;

  constructor(private readonly _mediator: IMediator) {
    this.#notification = new Notyf();

    this.#logService.info(this.#serviceName, 'Instance was created.');
  }

  fire({
    type,
    message,
    position = { x: 'right', y: 'top' },
    duration = 5000,
  }: {
    type: 'info';
    message: string;
    position?: INotyfPosition;
    duration?: number;
  }) {
    return this.#notification.open({
      type,
      message,
      position,
      icon: false,
      ripple: false,
      duration,
      dismissible: true,
      background: this.#themeService.palette['toast-surface'],
      className: 'notification',
    });
  }
}
